import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import { DeleteCompany, GetCompanies } from "../../../api/utility/companyAPI";

const ListCompany = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchCompanies = async () => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await GetCompanies();

      if (response.success) {
        showToast("success", response.message);
        const formattedData = response.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          name: item.name || "",
          address: item.address || "",
          email: item.email || "",
          phone: item.phone || "",
          mobile: item.mobile || "",
          website: item.website || ""
        }));

        setData(formattedData);
        setFilteredData(formattedData);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message || "Something went wrong");
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(
    () => {
      const results = data.filter(item =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
      setFilteredData(results);
    },
    [search, data]
  );

  const handleEditClick = id => {
    navigate(`/utility/company/edit/${id}`);
  };

  const handleDeleteClick = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async result => {
      if (result.isConfirmed) {
        dispatch({ type: "LOADER_START" });
        try {
          const response = await DeleteCompany(id);
          if (response.success) {
            showToast("success", response.message);
            setData(data.filter(item => item.id !== id));
            setFilteredData(filteredData.filter(item => item.id !== id));
          } else {
            showToast("error", response.message);
          }
        } catch (error) {
          showToast("error", error.message);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      }
    });
  };

  const columns = [
    { name: "S.No", selector: row => row.index, width: "8%" },
    { name: "Company Name", selector: row => row.name, sortable: true },
    { name: "Address", selector: row => row.address },
    { name: "Email", selector: row => row.email },
    { name: "Phone", selector: row => row.phone },
    { name: "Mobile", selector: row => row.mobile },
    { name: "Website", selector: row => row.website },
    {
      name: "Actions",
      cell: row =>
        <div>
          <button
            className="btn btn-primary me-2"
            onClick={() => handleEditClick(row.id)}
            id={`edit-${row.id}`}
          >
            <i className="fa fa-pencil-square-o" />
          </button>
          <UncontrolledTooltip target={`edit-${row.id}`}>
            Edit
          </UncontrolledTooltip>

          <button
            className="btn btn-danger"
            onClick={() => handleDeleteClick(row.id)}
            id={`delete-${row.id}`}
          >
            <i className="fa fa-trash-o" />
          </button>
          <UncontrolledTooltip target={`delete-${row.id}`}>
            Delete
          </UncontrolledTooltip>
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "15%"
    }
  ];

  const headers = [
    { label: "Company Name", key: "name" },
    { label: "Address", key: "address" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Mobile", key: "mobile" },
    { label: "Website", key: "website" }
  ];

  const ExportCSV = ({ data }) =>
    <CSVLink data={data} headers={headers} filename="companies.csv">
      <button className="btn btn-primary" id="export">
        Export
      </button>
      <UncontrolledTooltip target="export">Export to CSV</UncontrolledTooltip>
    </CSVLink>;

  return (
    <Fragment>
      <Breadcrumb parent="Company" title="List Company" />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="d-flex justify-content-between">
              <h5>List Company</h5>
              <Link to={`/utility/company/add`}>
                <button className="btn btn-primary" id="create">
                  Create Company
                </button>
                <UncontrolledTooltip target="create">
                  Create Company
                </UncontrolledTooltip>
              </Link>
            </div>

            <div className="row mt-2">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  placeholder="Search companies..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
              <div className="col-sm-6 text-end">
                <ExportCSV data={data} />
              </div>
            </div>
          </div>

          <div className="card-body">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListCompany;
